import {
  SOCIAL_NETWORK_LABELS,
  socialPeopleReportSchema,
  type SocialPeopleReport,
} from '@growup/site-shared';
import { Button, Card, DateInput, Field, Notice } from '@growup/ui';
import { useEffect, useState } from 'react';

import { getJson, messageOf } from '../api';
import { monthRange } from './CalendarView';
import { WorkTable } from './PieceViews';

const thisMonth = () =>
  new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Lisbon' }).format(new Date()).slice(0, 7);

/**
 * Por pessoa (RF-RS10, RF-RS11): o que cada um filmou, editou, aprovou e
 * publicou num periodo, em todos os meus planos, e as publicacoes por rede.
 */
export function PeopleView() {
  const [from, setFrom] = useState(() => monthRange(thisMonth()).from);
  const [to, setTo] = useState(() => monthRange(thisMonth()).to);
  const [asked, setAsked] = useState({ from, to });
  const [report, setReport] = useState<SocialPeopleReport | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setReport(null);
    setError(null);
    getJson(`/api/site/social/people?from=${asked.from}&to=${asked.to}`, socialPeopleReportSchema)
      .then(setReport)
      .catch((e: unknown) => setError(messageOf(e)));
  }, [asked]);

  return (
    <Card headingLevel={2} title="Por pessoa">
      <div className="flex flex-col gap-4">
        <p className="text-gu-ink-muted">
          Contam os passos feitos e os links de publicação postos no período (dias de Lisboa), sem
          as peças abandonadas. Até 92 dias de cada vez.
        </p>
        <form
          className="flex flex-wrap items-end gap-3"
          onSubmit={(e) => {
            e.preventDefault();
            setAsked({ from, to });
          }}
        >
          <Field label="De">
            <DateInput value={from} onChange={setFrom} />
          </Field>
          <Field label="Até">
            <DateInput value={to} onChange={setTo} />
          </Field>
          <Button type="submit" variant="secondary" disabled={from === '' || to === ''}>
            Ver
          </Button>
        </form>
        {error ? <Notice tone="danger">{error}</Notice> : null}
        {report === null && !error ? <p>A carregar…</p> : null}
        {report?.people.length === 0 ? <p>Ninguém marcou nada neste período.</p> : null}
        {report && report.people.length > 0 ? <WorkTable people={report.people} /> : null}
        {report && report.networks.length > 0 ? (
          <div className="flex flex-col gap-1">
            <h3 className="font-sub text-label font-bold uppercase">Publicações por rede</h3>
            <ul className="flex flex-wrap gap-3">
              {report.networks.map((n) => (
                <li key={n.network} className="border-2 border-gu-line px-3 py-1">
                  {SOCIAL_NETWORK_LABELS[n.network]}: <strong>{n.count}</strong>
                </li>
              ))}
            </ul>
          </div>
        ) : null}
      </div>
    </Card>
  );
}
